<ion-header mode="md">
    <ion-toolbar mode="ios" color="primary" performance class="ion-text-center">
        <ion-buttons slot="start">
            <ion-button fill="solid" color="danger" mode="ios" (click)="goBack()"> {{ 'generic.cancel' | translate
                }}</ion-button>
        </ion-buttons>
        <ion-title> {{ 'manageVersion.manageVersion' | translate | uppercase }}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="solid" color="secondary" mode="ios" (click)="saveProcess(version)"> {{ 'generic.save' |
                translate }}</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div class="max-page-width">
        <ng-container *ngIf="version">
            <ion-item *ngIf="ProcessType.EvaluationCalibration != version.type">
                <ion-label position="stacked"> {{ 'manageVersion.versionName' | translate }} *</ion-label>
                <ion-input type="text" [placeholder]="'manageVersion.versionName' | translate"
                    [(ngModel)]="version.versionName"></ion-input>
            </ion-item>

            <ion-item *ngIf="ProcessType.EvaluationCalibration == version.type" class="calibration-config">
                <ion-grid>
                    <ion-row>
                        <ion-col size="6">
                            <ion-item>
                                <ion-label position="stacked"> {{ 'manageVersion.versionName' | translate }}
                                    *</ion-label>
                                <ion-input type="text" [placeholder]="'manageVersion.versionName' | translate"
                                    [(ngModel)]="version.versionName"></ion-input>
                            </ion-item>
                        </ion-col>
                        <ion-col size="6">
                            <ion-item>
                                <ion-label position="stacked"> {{ 'manageVersion.selectCalibrationType' | translate }}*
                                </ion-label>
                                <ion-select [(ngModel)]="version.calibrationType">
                                    <ion-select-option *ngFor="let calibrationType of calibrationTypeList"
                                        [value]="calibrationType.Key">
                                        {{ calibrationType.TranslationKey | translate }}
                                    </ion-select-option>
                                </ion-select>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-item>
            <ng-container *ngIf="version.type == ProcessType.HeadEvaluation">
                <ion-item>
                    <ion-label position="stacked"> {{ 'generic.attributeName' | translate }}
                    </ion-label>
                    <ion-select (ionChange)="setHeadAttribute($event)" [(ngModel)]="version.headAttribute">
                        <ion-select-option *ngFor="let headAttribute of attributes" [value]="headAttribute.id">
                            {{ headAttribute.name | translate }}
                        </ion-select-option>
                    </ion-select>

                </ion-item>
            </ng-container>
            <ng-container *ngIf="processesWithValidations.includes(version.type)">
                <ion-item *ngIf="ProcessType.ThreeSixtyEvaluation == version.type">
                    <ion-label position="stacked"> {{ 'manageVersion.newSelectionVersion' | translate }} *</ion-label>
                    <ion-select (ionChange)="setSelectionId($event)" [(ngModel)]="version.selectionProcessId">
                        <ion-select-option *ngFor="let selectionVersion of threeSixtySelectionVersions"
                            [value]="selectionVersion.id">
                            {{ selectionVersion.versionName | translate }}
                        </ion-select-option>
                    </ion-select>
                    <ion-buttons slot="end">
                        <ion-button fill="solid" color="secondary" mode="ios" (click)="openProcessConfigModal(true)"
                            [disabled]="version.selectionProcessId === undefined || version.selectionProcessId === null">
                            {{ 'generic.configure' | translate }}
                        </ion-button>
                    </ion-buttons>
                </ion-item>

                <ion-item>
                    <ng-container [ngSwitch]="version?.type">
                        <ion-label position="stacked"> {{ 'manageVersion.newValidationVersion' | translate }}
                            *</ion-label>
                        <ion-select *ngSwitchCase="ProcessType.GoalInputs" (ionChange)="setValidationId($event)"
                            [(ngModel)]="version.validationProcessId">
                            <ion-select-option *ngFor="let validateVersion of goalsInputValidationsVersions"
                                [value]="validateVersion.id">
                                {{ validateVersion.versionName | translate }}
                            </ion-select-option>
                        </ion-select>
                        <ion-select *ngSwitchCase="ProcessType.GoalsReview" (ionChange)="setValidationId($event)"
                            [(ngModel)]="version.validationProcessId">
                            <ion-select-option *ngFor="let validateVersion of goalsReviewValidationsVersions"
                                [value]="validateVersion.id">
                                {{ validateVersion.versionName | translate }}
                            </ion-select-option>
                        </ion-select>
                        <ion-select *ngSwitchCase="ProcessType.ThreeSixtyEvaluation"
                            (ionChange)="setValidationId($event)" [(ngModel)]="version.validationProcessId">
                            <ion-select-option *ngFor="let validateVersion of threeSixtyValidationsVersions"
                                [value]="validateVersion.id">
                                {{ validateVersion.versionName | translate }}
                            </ion-select-option>
                        </ion-select>
                        <ion-select *ngSwitchCase="ProcessType.FinalFeedback" (ionChange)="setValidationId($event)"
                            [(ngModel)]="version.validationProcessId">
                            <ion-select-option *ngFor="let validateVersion of finalFeedbackValidationsVersions"
                                [value]="validateVersion.id">
                                {{ validateVersion.versionName | translate }}
                            </ion-select-option>
                        </ion-select>
                    </ng-container>
                    <ion-buttons slot="end">
                        <ion-button fill="solid" color="secondary" mode="ios" (click)="openProcessConfigModal()"
                            [disabled]="version.validationProcessId === undefined || version.validationProcessId === null">
                            {{ 'generic.configure' | translate }}
                        </ion-button>
                    </ion-buttons>
                </ion-item>
            </ng-container>

            <ng-container *ngIf="version.type === ProcessType.GenericProcess">
                <br /><br />
                <br /><br />

                <ion-item class="optionalManagerEvaluation">
                    <ion-toggle [(ngModel)]="version.anonymousReport"></ion-toggle>
                    <ion-label> {{ 'manageVersion.anonymousReport' | translate }}</ion-label>
                </ion-item>

                <ion-item class="optionalManagerEvaluation">
                    <ion-toggle [(ngModel)]="version.hrOnlyReport"></ion-toggle>
                    <ion-label> {{ 'manageVersion.hrOnlyReport' | translate }}</ion-label>
                </ion-item>
            </ng-container>

            <br /><br />
        </ng-container>

        <div class="lang-title">
            <h2>
                <ion-text color="primary"> {{ 'manageVersion.configureMultilanguage' | translate }}</ion-text>
            </h2>
            <div class="lang-selection">
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('pt-BR')"
                    [ngClass]="{ 'active': selectedLanguage === 'pt-BR' }">
                    PT
                </ion-button>
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('en-US')"
                    [ngClass]="{ 'active': selectedLanguage === 'en-US' }">
                    EN
                </ion-button>
                <ion-button fill="clear" mode="ios" class="ion-no-padding" (click)="changeSelectedLanguage('es-ES')"
                    [ngClass]="{ 'active': selectedLanguage === 'es-ES' }">
                    ES
                </ion-button>
            </div>
        </div>

        <ng-container *ngIf="version" [ngSwitch]="selectedLanguage">
            <app-process-configuration *ngSwitchCase="'pt-BR'"
                [configuration]="version.globalizationConfig['pt-BR']"></app-process-configuration>

            <app-process-configuration *ngSwitchCase="'en-US'"
                [configuration]="version.globalizationConfig['en-US']"></app-process-configuration>

            <app-process-configuration *ngSwitchCase="'es-ES'"
                [configuration]="version.globalizationConfig['es-ES']"></app-process-configuration>
        </ng-container>

        <ng-container *ngIf="version && canShowFlags">
            <app-processes-flags [version]="version" [processType]="_processType"
                [userAttributesOnProcessAllowedFlag]="userAttributesOnProcessAllowedFlag"></app-processes-flags>
        </ng-container>

        <app-processes-configurations [version]="version" [selfEvaluationVersions]="selfEvaluationVersions"
            [userAttributesOnProcessAllowedFlag]="userAttributesOnProcessAllowedFlag"
            (initializeQuestionGroups)="initializeQuestionGroups()"
            (buildGroupsSelectItems)="buildGroupsSelectItems()"></app-processes-configurations>

        <app-processes-questions-configuration [version]="version" [managerGroupsSelectItems]="managerGroupsSelectItems"
            [groupsSelectItems]="groupsSelectItems"></app-processes-questions-configuration>
    </div>
</ion-content>